import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
interface WaveWinnersDropHeaderAuthorHandleProps {
  readonly winner: ApiWaveDecisionWinner;
}
export default function WaveWinnersDropHeaderAuthorHandle(t0) {
  const $ = _c(6);
  const {
    winner
  } = t0;
  const t1 = winner.drop.author.handle ?? winner.drop.author.id;
  const t2 = `/${winner.drop.author.handle}`;
  let t3;
  if ($[0] !== t2 || $[1] !== winner.drop.author.handle) {
    t3 = <Link href={t2} onClick={_temp} className="tw-no-underline tw-text-iron-200 desktop-hover:hover:tw-underline desktop-hover:hover:tw-text-opacity-80 tw-transition tw-duration-300 tw-ease-out">{winner.drop.author.handle}</Link>;
    $[0] = t2;
    $[1] = winner.drop.author.handle;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t1 || $[4] !== t3) {
    t4 = <p className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold"><UserProfileTooltipWrapper user={t1}>{t3}</UserProfileTooltipWrapper></p>;
    $[3] = t1;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}
function _temp(e) {
  return e.stopPropagation();
}